import { render } from "./ListApplications.vue?vue&type=template&id=1e505160&ts=true"
import script from "./ListApplications.vue?vue&type=script&lang=ts"
export * from "./ListApplications.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/wp-content/themes/w2w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__